import { render } from "./ProductScoreOk.vue?vue&type=template&id=c99b2ff6"
import script from "./ProductScoreOk.vue?vue&type=script&lang=js"
export * from "./ProductScoreOk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__